<script lang="ts">
	import { prefs } from '#library/stores.ts'
	import Button from '#components/button.svelte'
	import { fly } from 'svelte/transition'
</script>

<div class="cookie" in:fly={{ y: 50 }} out:fly={{ y: 50 }}>
	<div class="title">We Use Cookies</div>
	<div class="body">
		We use cookies to ensure our website works properly and to understand how visitors use our site. This helps
		us provide the best possible experience for our school community.
	</div>
	<Button onclick={() => ($prefs.cookie = true)} fill>Accept</Button>
	<div class="action">
		<Button onclick={() => ($prefs.cookie = false)} fill text>Opt-out</Button>
	</div>
</div>

<style>
	.cookie {
		--c-foreground: var(--c-pink);
		--c-midground: var(--c-white);
		--c-background: var(--c-lupton);

		background-color: var(--c-background);
		color: var(--c-midground);
		inset: auto auto 0;
		max-width: min(30rem, 100%);
		padding: 1.25rem;
		position: fixed;
		z-index: 2;

		@media (--from-mobile) {
			inset: auto 1.5rem 1.5rem auto;
		}
	}

	.title {
		font: 600 var(--f-h6);
		letter-spacing: var(--ls-h6);
		margin-block-end: 0.5rem;
	}

	.body {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-end: 1.5rem;
	}

	.action {
		--c-foreground: var(--c-midground);
		margin-block: 1.5rem 0.5rem;
	}
</style>
